import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Structure/Header';
import Footer from '../../components/Structure/Footer';
import MainContent from '../../components/Structure/Content/Main';
import Sidebar from '../../components/Structure/Sidebar';
import PageHelper from '../../helpers/page-helper';
import { setCurrentStep } from '../../store/application/actions';
import { STEP_PRODUCTS } from '../../helpers/steps';
import Product from '../../components/Products/Product';
import UrlHelper from '../../helpers/url-helper';

const ProductsPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const property = useSelector(state => state.property);
  const application = useSelector(state => state.application);
  const products = useSelector(state => state.products);
  const availability = useSelector(state => state.availability);
  const reservation = useSelector(state => state.reservation);
  const { arrivalDate, departureDate, couponCode, totalAdults: adults, totalChildren: children, askSuiteId } = reservation;
  const { currentStep, widget } = application;
  const { ready } = availability;
  const [loaded, setLoaded] = useState(false);
  const isWidget = widget === '1';

  useEffect(() => {
    if ((!ready || !property.ready || !availability.ready) && !loaded) {
      PageHelper.verifyInternalPages(history, location);
    }
  }, [ready, property.ready, availability.ready, loaded, history, location]);

  useEffect(() => {
    if (ready && property.ready && availability.ready && !loaded) {
      setLoaded(true);
    }
  }, [ready, property.ready, availability.ready, loaded]);

  useEffect(() => {
    if (currentStep !== STEP_PRODUCTS) {
      dispatch(setCurrentStep(STEP_PRODUCTS, true));
    }
  }, [currentStep, dispatch]);

  useEffect(() => {
    if (loaded && products.ads.length <= 0) {
      history.push(
        UrlHelper.toInternalRoute(
          'checkout',
          arrivalDate,
          departureDate,
          couponCode,
          '',
          adults,
          children,
          null,
          askSuiteId,
          widget,
          '',
        ),
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, products.ads.length]);

  if ((!ready || !property.ready || !availability.ready) && !loaded) {
    return null;
  }

  if (products.ads.length <= 0) {
    return null;
  }

  const sidebar = (
    <Sidebar
      property={property}
      reservation={reservation}
      page={STEP_PRODUCTS}
      submitButtonReleased={true} 
      showAbout
      showCoupon
      showCheckoutSummary
    />
  );

  const widgetStyle = isWidget ? { marginTop: `-40px` } : {};

  return (
    <Fragment>
      <Header />

      <MainContent sidebar={sidebar}>
        <Fragment>
          <div className="card mt-n4 mb-4">
            <div className="card-body" style={widgetStyle}>
              <div className="row">
                <div className="col-12">
                  <h2>{t('titles.productsAndServices')}</h2>
                  <div className="row mb-3 track-day">
                    {products.ads.map(product => {
                      return (
                        <Product
                          key={`product-${product.id}`}
                          product={product}
                          reservationProducts={reservation.products}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </MainContent>

      <Footer />
    </Fragment>
  );
};

export default ProductsPage;
